import React from 'react';

import {useTranslation} from 'react-i18next';

import {useHistory} from 'react-router-dom';

import styled from 'styled-components';

import {Title} from 'components/ui-kit/Title';

import {colors} from 'theme';

import {Container} from './styled';

export function NoAccess() {
    const {t} = useTranslation();
    const history = useHistory();

    const onBack = () => {
        if (history.length) history.goBack();
        else history.push('/dashboard');
    };
    return (
        <Container>
            <Title size={3}>{t('components.noAccess.title')}</Title>
            <Back onClick={onBack}>{t('components.noAccess.toBack')}</Back>
        </Container>
    );
}

const Back = styled.div`
    color: ${colors.brandPrimary};
    font-size: 20px;
    cursor: pointer;
`;
